import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from '@tanstack/react-router'
import { router } from '@/router/routeTree'
import { useAuthStore } from '@/stores/authStore'
import { useSessionMonitor } from '@/hooks/useSessionMonitor'
import { Toaster, toast } from 'sonner'
import { useEffect } from 'react'
import './index.css'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if ((query.options.meta as Record<string, unknown>)?.suppressGlobalError) return
      toast.error(error instanceof Error ? error.message : 'Erro ao carregar dados')
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if ((mutation.options.meta as Record<string, unknown>)?.suppressGlobalError) return
      toast.error(error instanceof Error ? error.message : 'Erro ao salvar dados')
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
})

function SessionMonitorWrapper() {
  useSessionMonitor()
  return null
}

function App() {
  useEffect(() => { useAuthStore.getState().initSession() }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <SessionMonitorWrapper />
      <RouterProvider router={router} context={{ queryClient }} />
      <Toaster position="top-right" richColors closeButton duration={4000} />
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  )
}

export default App
